import React from 'react';
import { Box, Typography } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { fmtNumber } from '../utils';

interface IDictProgressProps {
  total: number;
  learned: number;
  height?: number;
  showStats?: boolean;
}

const Stat: React.FC<{ color: string; n: number; label: string }> = ({
  color,
  n,
  label,
}) => (
  <Box
    component={'span'}
    sx={{
      alignItems: 'baseline',
      color: 'text.secondary',
      display: 'inline-flex',
      fontSize: 13,
      gap: 0.75,
    }}
  >
    <Box
      component={'span'}
      sx={{
        alignSelf: 'center',
        bgcolor: color,
        borderRadius: '50%',
        height: 8,
        width: 8,
      }}
    />
    <Box
      component={'b'}
      sx={{ color: 'text.primary', fontSize: 16, fontWeight: 800 }}
    >
      {fmtNumber(n)}
    </Box>
    {label}
  </Box>
);

const DictProgress: React.FC<IDictProgressProps> = ({
  total,
  learned,
  height = 8,
  showStats = true,
}) => {
  const { mode } = useColorScheme();
  const pct = total ? Math.round((learned / total) * 100) : 0;
  const green = mode === 'dark' ? '#74C98A' : '#5FA56F';
  const indigo = mode === 'dark' ? '#9B7CFF' : '#3B2C93';

  return (
    <Box sx={{ width: '100%' }}>
      {showStats && (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 2.25,
            mb: 1.125,
          }}
        >
          <Stat color={indigo} n={total} label={'додано'} />
          <Stat color={green} n={learned} label={'вивчено'} />
          <Box sx={{ flex: 1 }} />
          <Typography sx={{ color: green, fontSize: 14, fontWeight: 700 }}>
            {pct}%
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          bgcolor: 'background.default',
          borderRadius: 999,
          height,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            bgcolor: green,
            borderRadius: 999,
            height: '100%',
            transition: 'width .4s cubic-bezier(0.22,1,0.36,1)',
            width: `${pct}%`,
          }}
        />
      </Box>
    </Box>
  );
};

export default DictProgress;
